import { IonCard, IonCardContent, IonText } from '@ionic/react';
import { SimpleProduct } from '../../types/product.type';
import './ProductCard.scss'
import { getProductRawPrice, getProductUrl, getProductImageUrl, getPriceFactor } from '../../functions/product.functions';
import { useAppContext } from '../../services/app-context.service';
import ProgressiveImg from '../ProgressiveImg';
type Props = {
    product: SimpleProduct
}
const ProductCard: React.FC<Props> = ({ product }) => {
    const data = useAppContext()
    const priceFactor = getPriceFactor(data.settings)
    const soldCount = product.sale_info?.sale_quantity_90days || product.sale_info?.sale_quantity
    const sellerScore = product.shop_info?.score_info?.composite_score || product.goods_score
    return <IonCard routerLink={getProductUrl(product.item_id)} className='product'>
        <IonCardContent>
            <div className="text-center">
                <ProgressiveImg src={getProductImageUrl(product.img, 250)}/>
            </div>

            <h2>{product.title}</h2>
            <div className='sale-info'>
                {/* <IonText className='regular'>৳ {product.regular_price}</IonText> */}
                <IonText className='price' color='primary'>৳ {getProductRawPrice(product.price, priceFactor)}</IonText>
                <div className='right-info'>
                    {!!soldCount && <IonText className='sold'>{soldCount} sold</IonText>}
                    {!!sellerScore && (
                        <div className='seller-rating'>
                            <span className='star'>★</span>
                            <span className='score'>{sellerScore}</span>
                        </div>
                    )}
                </div>
            </div>
        </IonCardContent>
    </IonCard>
};

export default ProductCard;
